import classnames from 'classnames';
import CogwheelIcon from 'components/icons/CogwheelIcon';
import HelpIcon from 'components/icons/HelpIcon';
import usePathnameWithNoLangCode from 'hooks/usePathnameWithNoLangCode';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const CSS = require('./AgendaBottomBar.module.scss');

function AgendaBottomBar() {
  const location = useLocation();
  const pathname = usePathnameWithNoLangCode();

  return (
    <nav className={CSS.AgendaBottomBar}>
      <Link
        to={{
          search: location.search,
          pathname: '/host-agenda/create-event/',
        }}
        className={CSS.TextLink}
      >
        Create Event
      </Link>
      <Link
        to={{
          search: location.search,
          pathname: '/host-agenda/onboarding/',
        }}
        className={classnames(CSS.IconLink, {
          [CSS.ActiveIconLink]: pathname?.includes('/host-agenda/onboarding/'),
        })}
      >
        <HelpIcon width={24} height={24} className={CSS.Icon} />
      </Link>
      <Link
        to={{
          search: location.search,
          pathname: '/host-agenda/settings/',
        }}
        className={classnames(CSS.IconLink, {
          [CSS.ActiveIconLink]: pathname?.includes('/host-agenda/settings/'),
        })}
      >
        <CogwheelIcon width={24} height={24} className={CSS.Icon} />
      </Link>
    </nav>
  );
}

export default AgendaBottomBar;
